import httpclient from "@/api/http-client";
export default {
  async getPaymentReceipt(transactionId) {
    var url = `/api/Documents/payments/subscription/receipt/${transactionId}`;
    return await httpclient.get(url, { responseType: "blob" });
  },
};
